
<ngx-spinner class=" z-auto" bdColor = "rgba(0,0,0,0.84)" size = "medium" color = "#038f98" type = "ball-clip-rotate-multiple" [fullScreen] = "true"><p style="color: white" > {{'GLOBAL.LABELS.LOADING' | translate}} </p></ngx-spinner>
  <div class=" grid grid-cols-2 gap-1 px-4 py-2">
    <form [formGroup]="formExercise">
      <div class="grid grid-flow-col gap-1">
        
        <oden-select label="Tipo de ejercicio" [options]="exerciseTypes"  formControlName="t_exercise"></oden-select>
        <oden-input formControlName="search" type="search" label="{{'GLOBAL.INPUTS.SEARCH' | translate}}" placeholder="{{'GLOBAL.INPUTS.SEARCH_HERE' | translate}}"></oden-input>
      </div>
    </form>
    <div class="text-right mt-6">
      <oden-button (click)="regresar()" color="secondary" text="{{'GLOBAL.BUTTONS.CANCEL' | translate}}"></oden-button>
    </div>
    <div class="col-span-2">
      <div class="mt-5">
        <ion-segment color="secondary" (click)="getListAll(1)" [(ngModel)]="typeGym">
          <ion-segment-button class="hover:bg-jet-black-700 rounded-md hover:text-black"   value="1" >
            <ion-label class="text-xs text-white">Oden</ion-label>
          </ion-segment-button>
          <ion-segment-button class="hover:bg-jet-black-700 rounded-md hover:text-black"   value="2" *ngIf="plan.data && plan.data?.plan!='free' && plan.data?.plan!='basic'">
            <ion-label class="text-xs text-white">Local</ion-label>
          </ion-segment-button>
        </ion-segment>
      </div>
    </div>
    <oden-card class="col-span-2 text-white">
      <oden-card-content >
        <div class=" h-72 overflow-y-scroll col-span-2 grid grid-cols-4 gap-1">
          <div *ngFor="let ex of exercises">
            <oden-card (click)="selectExercise(ex)" class=" cursor-pointer hover:bg-jet-black-700 hover:border-jet-black-750">
              <oden-card-content >
               <div>
                 <img class="h-20 m-auto" src="{{ex.banner}}">
               </div>
              </oden-card-content>
              <oden-card-actions>
               <p>{{ex.nombre}}</p>
              </oden-card-actions>
            </oden-card>
          </div>
        </div>
      </oden-card-content>
      <oden-card-actions>
          <div class="w-full px-14 grid grid-cols-4 gap-8 grid-flow-row">
            <oden-pagination (changePaginator)="getListAll($event)" [items]="10" [currentPage]="pagInfo?.currentPage" [totalPages]="pagInfo.totalPages" class="col-span-4"></oden-pagination>
          </div>
      </oden-card-actions>
    </oden-card>
    
    
  </div>
